import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import HotRankList from "@/components/feature/HotRankList";

const featured = articles.find((item) => item.heat > 300) ?? articles[0];

const tickerItems = articles.slice(0, 5);

export default function HomeHero() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="flex items-center gap-3 overflow-hidden border-b border-background-200 px-4 py-2.5 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-label font-medium text-background-50">
          <i className="ri-flashlight-fill animate-pulse-dot"></i>
          今日速览
        </span>
        <div className="flex min-w-0 flex-1 items-center gap-6 overflow-hidden">
          {tickerItems.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="hidden shrink-0 items-center gap-2 text-sm font-label text-foreground-600 transition-colors hover:text-primary-700 md:flex"
            >
              <span className="h-1 w-1 rounded-full bg-accent-500"></span>
              <span className="line-clamp-1 max-w-[260px]">{item.title}</span>
            </Link>
          ))}
          <Link
            to={`/article/${tickerItems[0].id}`}
            className="flex min-w-0 items-center gap-2 text-sm font-label text-foreground-600 md:hidden"
          >
            <span className="h-1 w-1 rounded-full bg-accent-500"></span>
            <span className="line-clamp-1">{tickerItems[0].title}</span>
          </Link>
        </div>
        <Link
          to="/hot"
          className="hidden shrink-0 items-center gap-1 text-xs font-label text-primary-700 transition-colors hover:text-primary-800 sm:flex"
        >
          完整热榜
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-6 px-4 py-8 md:px-8 md:py-10 lg:grid-cols-3">
        <article className="relative col-span-1 h-[360px] overflow-hidden rounded-lg md:h-[460px] lg:col-span-2 animate-fade-up">
          <img
            src={featured.cover}
            alt={`今日最大瓜：${featured.title} - 52吃瓜网热点事件配图`}
            title={`${featured.title} 52吃瓜网`}
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/45 to-black/15"></div>
          <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-label font-medium text-background-50">
                今日最大瓜
              </span>
              <span className="rounded-full bg-background-50/90 px-3 py-1 text-xs font-label text-foreground-800 backdrop-blur">
                {featured.category}
              </span>
              <span className="flex items-center gap-1 rounded-full bg-accent-500/90 px-3 py-1 text-xs font-label text-accent-950">
                <i className="ri-fire-line"></i>
                热度 {featured.heat}万
              </span>
            </div>
            <h2 className="mt-4 max-w-2xl font-heading text-2xl font-black leading-tight text-white md:text-4xl">
              {featured.title}
            </h2>
            <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-white/80 font-label md:block">
              {featured.excerpt}
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <Link
                to={`/article/${featured.id}`}
                className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                查看事件梳理
              </Link>
              <span className="flex items-center gap-1.5 text-xs font-label text-white/70">
                <i className="ri-time-line"></i>
                {featured.publishedAt} 更新
              </span>
            </div>
          </div>
        </article>

        <aside className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 animate-fade-up">
          <div className="flex items-center justify-between">
            <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-bar-chart-box-line text-primary-600"></i>
              实时热度榜
            </h2>
            <Link
              to="/hot"
              className="text-xs font-label text-foreground-500 transition-colors hover:text-primary-700"
            >
              全部
            </Link>
          </div>
          <p className="mt-1 text-xs font-label text-foreground-400">
            每 10 分钟根据讨论量刷新
          </p>
          <div className="mt-3">
            <HotRankList limit={6} compact />
          </div>
        </aside>
      </div>
    </section>
  );
}